module.exports = __webpack_public_path__ + "static/media/watch_nav_accessories.d8543dbd.svg";